"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _NotificationBannerInline = _interopRequireDefault(require("../NotificationBannerInline"));

var _PopupMessage = _interopRequireDefault(require("./PopupMessage.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var mobileStyle = (0, _styledComponents.css)(["margin:auto;width:calc(100% - ", "px);right:0;left:0;"], _constant.MOBILE_MARGIN_BOTTOM * 2);
var desktopStyle = (0, _styledComponents.css)(["max-width:", "px;right:", "px;"], _constant.MAX_WIDTH, _constant.DESKTOP_MARGIN_LEFT);
var webCheckinDateExpired = (0, _styledComponents.css)(["width:920px;height:40px;margin-top:100px;"]);

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "PopupMessage__Wrapper",
  componentId: "sc-14kevno-0"
})(["z-index:", ";position:", ";display:", ";", ""], function (_ref) {
  var zIndex = _ref.zIndex;
  return zIndex;
}, function (_ref2) {
  var isMweb = _ref2.isMweb;
  return isMweb ? null : 'fixed';
}, function (_ref3) {
  var isMweb = _ref3.isMweb;
  return isMweb ? null : 'flex';
}, function (_ref4) {
  var isMobile = _ref4.isMobile,
      isCheckinDateExpired = _ref4.isCheckinDateExpired,
      isMweb = _ref4.isMweb;

  if (isCheckinDateExpired) {
    return webCheckinDateExpired;
  }

  if (isMobile || isMweb) {
    return mobileStyle;
  }

  return desktopStyle;
});

var PopupMessage = function PopupMessage(_ref5) {
  var accessible = _ref5.accessible,
      customProperties = _ref5.customProperties,
      theme = _ref5.theme,
      isShow = _ref5.isShow,
      message = _ref5.message,
      onClose = _ref5.onClose,
      _ref5$topPosition = _ref5.topPosition,
      topPosition = _ref5$topPosition === void 0 ? _constant.DEFAULT_TOP_POSITION : _ref5$topPosition,
      autoHideDuration = _ref5.autoHideDuration,
      zIndex = _ref5.zIndex,
      type = _ref5.type,
      isMobile = _ref5.isMobile,
      showLeftIcon = _ref5.showLeftIcon,
      isClosable = _ref5.isClosable,
      showOnTopMobile = _ref5.showOnTopMobile,
      ctaColor = _ref5.ctaColor,
      ctaSize = _ref5.ctaSize,
      isBannerClickable = _ref5.isBannerClickable,
      isCheckinDateExpired = _ref5.isCheckinDateExpired,
      isMweb = _ref5.isMweb;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)(topPosition),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      currentPosition = _useState2[0],
      setCurrentPosition = _useState2[1];

  var ticking = (0, _react.useRef)(false);
  var timerAutoHide = (0, _react.useRef)();
  var handleOnScroll = (0, _react.useCallback)(function () {
    var frameReq;

    if (typeof window !== 'undefined' && !ticking.current) {
      frameReq = window.requestAnimationFrame(function () {
        if (window.scrollY <= _constant.HEADER_HEIGHT) {
          setCurrentPosition(topPosition - window.scrollY);
        } else {
          setCurrentPosition(topPosition - _constant.HEADER_HEIGHT);
        }

        ticking.current = false;
      });
      ticking.current = true;
    }

    return function () {
      return frameReq && window.cancelAnimationFrame(frameReq);
    };
  }, [topPosition]);
  (0, _react.useEffect)(function () {
    if (isShow && autoHideDuration) {
      timerAutoHide.current = setTimeout(function () {
        onClose();
      }, autoHideDuration);
    }

    return function () {
      return clearTimeout(timerAutoHide.current);
    };
  }, [isShow, autoHideDuration, onClose]);
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined' && !isMobile) {
      window.addEventListener('scroll', handleOnScroll);
    }

    return function () {
      if (typeof window !== 'undefined' && !isMobile) {
        window.removeEventListener('scroll', handleOnScroll);
      }
    };
  }, [handleOnScroll, isMobile]);
  var wrapperStyle;

  if (isMobile) {
    if (showOnTopMobile) {
      wrapperStyle = {
        top: "".concat(_constant.HEADER_HEIGHT + _constant.MOBILE_MARGIN_BOTTOM, "px")
      };
    } else {
      wrapperStyle = {
        bottom: "".concat(_constant.MOBILE_MARGIN_BOTTOM, "px")
      };
    }
  } else {
    wrapperStyle = {
      top: "".concat(currentPosition, "px")
    };
  }

  var getMain = function getMain() {
    return isShow && /*#__PURE__*/_react.default.createElement(Wrapper, {
      tabIndex: tabIndex,
      style: wrapperStyle,
      isMobile: isMobile,
      zIndex: zIndex,
      isCheckinDateExpired: isCheckinDateExpired,
      isMweb: isMweb
    }, /*#__PURE__*/_react.default.createElement(_NotificationBannerInline.default, {
      onClose: onClose,
      message: message,
      accessible: accessible,
      customProperties: customProperties,
      type: type,
      showLeftIcon: showLeftIcon,
      closable: isClosable,
      ctaColor: ctaColor || undefined,
      ctaSize: ctaSize || undefined,
      isBannerClickable: isBannerClickable
    }));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

PopupMessage.propTypes = _PopupMessage.default.PropTypes;
PopupMessage.defaultProps = _PopupMessage.default.DefaultProps;
var _default = PopupMessage;
exports.default = _default;